import { render, staticRenderFns } from "./_remapMatch.vue?vue&type=template&id=375864e1&scoped=true&lang=pug&"
import script from "./_remapMatch.vue?vue&type=script&lang=js&"
export * from "./_remapMatch.vue?vue&type=script&lang=js&"
import style0 from "./_remapMatch.vue?vue&type=style&index=0&id=375864e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375864e1",
  null
  
)

export default component.exports